export enum Roles {
  Superadmin = 1,
  Host = 2,
  User = 3,
}
